module.exports = __webpack_public_path__ + "img/location-img.61dc2484.svg";